module.exports = __webpack_public_path__ + "static/media/theWheel.6425bc7f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theWheel.svg
// module id = 506
// module chunks = 0